module.exports = __webpack_public_path__ + "triangle.png?3d64e75a4815831f2b554d95d5f65d04";